<template>
    <input-radio 
    @input="v => $emit('input', v)"
    :options="options"
    :name="$trans(row.name)"
    :content="row.display_content"
    v-bind="$attrs" />
</template>

 
<script>

    import {mapState} from 'vuex'

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        },

        computed: {
            options() {
                var options = this.$trans(this.row.value)

                return _.map(options, (item, value) => {
                    return {
                        label: _.get(item, 'name', item),
                        sublabel: _.get(item, 'sublabel', ''),
                        value: value,
                        desc: _.get(item, 'desc', ''),
                    }
                })
            }
        }

    }
</script>